import {TradeDirection} from '../TradeDirection';

/**
 * P/L from prices and size: long → (exit − entry) × size, short → (entry − exit) × size.
 * Gross price move only (no commission).
 */
export function calculateTradeProfitLoss(
  direction: TradeDirection,
  positionSize: number,
  entryPrice: number,
  exitPrice: number,
): number | undefined {
  if (!Number.isFinite(entryPrice) || !Number.isFinite(exitPrice) || !Number.isFinite(positionSize)) {
    return undefined;
  }
  if (positionSize <= 0 || entryPrice <= 0 || exitPrice <= 0) return undefined;

  const diff = direction === TradeDirection.LONG ? exitPrice - entryPrice : entryPrice - exitPrice;
  return diff * positionSize;
}
